import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25c0e21a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=25c0e21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0e21a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BuyGoodsListFilter: require('/drone/src/components/BuyGoodsList/filter.vue').default,ListLoading: require('/drone/src/components/ListLoading/index.vue').default,GoodsAccountGeneralItem: require('/drone/src/components/GoodsBox/GoodsAccountGeneralItem.vue').default,GoodsAccountText: require('/drone/src/components/GoodsBox/GoodsAccountText.vue').default,GoodsAccountImg: require('/drone/src/components/GoodsBox/GoodsAccountImg.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default,GoodsEveryDeal: require('/drone/src/components/GoodsEveryDeal/index.vue').default})
